import { CacheService } from 'web_core_library';
import { IWorkoutSuccessPredictor, IWorkoutSuccessPredictorCache } from './types';

async function init() {
  await CacheService.init();
}

function get(workoutId: number) {
  try {
    return CacheService.load<IWorkoutSuccessPredictorCache>(`success-predictor-${workoutId}`);
  } catch (error) {
    return;
  }
}

function set(data: IWorkoutSuccessPredictor) {
  try {
    const cacheValue: IWorkoutSuccessPredictorCache = {
      ...data,
      syncTimestamp: Date.now(),
    };
    return CacheService.save(`success-predictor-${data.workoutId}`, cacheValue);
  } catch (error) {
    return;
  }
}

const SuccessPredictorCacheService = {
  get,
  init,
  set,
};
export default SuccessPredictorCacheService;
